import React from 'react';
import styled from 'styled-components';
import {Column, Row} from './../../../common/Layouts/Layouts';

import * as S from './HotelDetailsLoader.styles';

const HotelDetailsLoader = () => (
  <S.HotelDetailsLoaderComponentWrapDiv>
    <Column>
      <S.HotelDetailsFirstLoaderWrapDiv>
        <S.RatingLoaderWrapSpan></S.RatingLoaderWrapSpan>
        <S.RatingLoaderWrapSpan></S.RatingLoaderWrapSpan>
      </S.HotelDetailsFirstLoaderWrapDiv>
      <S.HotelNameLoaderWrapDiv></S.HotelNameLoaderWrapDiv>
      <S.AddressLoaderWrapDiv></S.AddressLoaderWrapDiv>
    </Column>

    <Column>
      <S.AmminitiesLoaderWrapDiv></S.AmminitiesLoaderWrapDiv>
      <S.AmminitiesLoaderWrapDiv></S.AmminitiesLoaderWrapDiv>
      <S.AmminitiesLoaderWrapDiv></S.AmminitiesLoaderWrapDiv>
    </Column>
  </S.HotelDetailsLoaderComponentWrapDiv>
);

export default HotelDetailsLoader;
